var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}},[_c('template',{slot:"left"},[_c('van-icon',{attrs:{"name":"arrow-left","size":"18","color":_vm.backIconColor}})],1),_c('template',{slot:"right"})],2),(_vm.isPlaceholder)?_c('div',{staticClass:"nav-top-placeholder"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }